import React, { useEffect, useState } from "react";
import "./payment.css";
import { SubStore } from "../store/subStore";
import { RedirectStore } from "../store/redirectStore";
//import { PlanStore } from "../store/planStore";
import { useHistory } from "react-router-dom";

//import Global from "../../global";
import InPlayer from "../backend/inplayer";
//import Success from "./success";
import CarouselContentLoader from "../loader/contentLoader";

let valid = require("card-validator");

const Payment = (props) => {
  const [paypal, setPaypal] = useState(false);
  const [applyCode, setApplyCode] = useState(false);
  const [owner, setOwner] = useState("Owner Name");
  const [voucher, setVoucher] = useState("");
  const [cardNumber, setCardNumber] = useState("**** **** **** ****");
  const [cardMonth, setCardMonth] = useState("mm");
  const [cardYear, setCardYear] = useState("yy");
  const [cvv, setcvv] = useState("***");
  const [back, setBack] = useState(false);
  const [couponCheck, setcouponCheck] = useState(false);
  const [cardType, setCardType] = useState("");
  const [cardValid, setCardValid] = useState(true);
  const [voucherValid, setvoucherValid] = useState(true);
  const [monthValid, setMonthValid] = useState(true);
  const [cvvValid, setCvvValid] = useState(true);
  const [nameValid, setnameValid] = useState(true);
  const selectedPlan = SubStore.useState((s) => s.selectPrice);
  //const paidplan = PlanStore.useState((s) => s.plan);
  const [loading, isLoading] = useState(true);
  let history = useHistory();

  const queryParams = new URLSearchParams(window.location.search);
  const PayerId = queryParams.get("PayerID");
  const redirect = queryParams.get("redirect");
  const type = queryParams.get("type");

  useEffect(() => {
    if (selectedPlan === null && PayerId === null) {
      let path = "/" + props.match.params.AppId + "/premium";
      history.push(path);
    }

    isLoading(false);
  }, [selectedPlan, history, props.match.params.AppId, PayerId]);

  const validateCard = () => {
    let numberValidation = valid.number(cardNumber);
    if (numberValidation.isPotentiallyValid && numberValidation.card) {
      setCardType(numberValidation.card.niceType);
      setCardValid(true);
    } else {
      setCardType("");
      setCardValid(false);
    }
  };
  const validateMonth = () => {
    if (cardMonth && cardYear && cardMonth !== "mm" && cardYear !== "yy") {
      let validMonth = valid.expirationDate(cardMonth + "/" + cardYear);

      if (validMonth.isValid || validMonth.isPotentiallyValid) {
        setMonthValid(true);
      } else {
        setMonthValid(false);
      }
    } else {
      setMonthValid(false);
    }
  };
  const validateCVV = () => {
    let validcvv =
      cardType === "American Express" ? valid.cvv(cvv, 4) : valid.cvv(cvv);

    if (validcvv.isValid) {
      setCvvValid(true);
    } else {
      setCvvValid(false);
    }
  };

  const validateName = () => {
    let validName = valid.cardholderName(owner);

    if (validName.isPotentiallyValid) {
      setnameValid(true);
    } else {
      setnameValid(false);
    }
  };

  const validateVoucher = (event) => {
    event.preventDefault();
    if (!applyCode) {
      setcouponCheck(true);
      InPlayer.Voucher.getDiscount({
        voucherCode: voucher,
        accessFeeId: selectedPlan.id,
      })
        .then((data) => {
          setvoucherValid(true);
          setcouponCheck(false);
          setApplyCode(true);
        })
        .catch((error) => {
          setvoucherValid(false);
          setVoucher("");
          setcouponCheck(false);
          setApplyCode(false);
        });
    }
  };

  const confirmPayment = (event) => {
    event.preventDefault();
    isLoading(true);
    let nav = null;
    if (redirect && type) {
      nav = { redirect: redirect, type: type };
      RedirectStore.update((s) => {
        s.redirectPlan = nav;
      });
    }
    let numberValidation = valid.number(cardNumber);
    let validMonth = valid.expirationDate(cardMonth + "/" + cardYear);
    let validcvv =
      cardType === "American Express" ? valid.cvv(cvv, 4) : valid.cvv(cvv);
    let nameValidation = valid.cardholderName(owner);
    if (validMonth && validcvv && numberValidation) {
      if (
        validMonth.isPotentiallyValid &&
        validcvv.isValid &&
        numberValidation.isPotentiallyValid &&
        nameValidation.isPotentiallyValid
      ) {
        setCardValid(true);
        setMonthValid(true);
        setCvvValid(true);
        setnameValid(true);

        if (selectedPlan.access_type.name === "subscription") {
          InPlayer.Subscription.createSubscription({
            number: cardNumber,
            cardName: owner,
            expMonth: cardMonth,
            expYear: cardYear,
            cvv: cvv,
            accessFee: selectedPlan.id,
            paymentMethod: 1,
            referrer: window.location.href,
            voucherCode: voucher,
          })
            .then((data) => {})
            .catch((error) => {
              isLoading(false);
            });
        } else if (
          selectedPlan.access_type.name !== "subscription" &&
          selectedPlan.access_type.name !== "freemium"
        ) {
          InPlayer.Payment.createPayment({
            number: cardNumber,
            cardName: owner,
            expMonth: cardMonth,
            expYear: cardYear,
            cvv: cvv,
            accessFee: selectedPlan.id,
            paymentMethod: 1,
            referrer: window.location.href,
            voucherCode: voucher,
            returnUrl: "https://event.inplayer.com/staging",
          })
            .then((data) => {})
            .catch((error) => {
              isLoading(false);
            });
        } else {
          isLoading(false);
        }
      } else {
        setCardValid(validMonth.isPotentiallyValid ? true : false);
        setMonthValid(validcvv.isValid ? true : false);
        setCvvValid(numberValidation.isPotentiallyValid ? true : false);
        setnameValid(numberValidation.isPotentiallyValid ? true : false);
        isLoading(false);
      }
    } else {
      setCardValid(false);
      setMonthValid(false);
      setCvvValid(false);
      setnameValid(false);
      isLoading(false);
    }
  };
  const paypaled = (event) => {
    event.preventDefault();
    let nav = null;
    if (redirect && type) {
      nav = { redirect: redirect, type: type };
      RedirectStore.update((s) => {
        s.redirectPlan = nav;
      });
    }
    isLoading(true);
    InPlayer.Payment.getPayPalParams({
      origin: window.location.href,
      accessFeeId: selectedPlan.id,
      paymentMethod: 2,
      voucherCode: voucher,
    })
      .then((data) => {
        window.location.href = data.data.endpoint;
        isLoading(false);
      })
      .catch((error) => {
        isLoading(false);
      });
  };

  if (loading || PayerId !== null) {
    return (
      <CarouselContentLoader
        textLoader={
          PayerId !== null
            ? "We are Confirming your Payment with Paypal. Please Wait"
            : ""
        }
      />
    );
  } else {
    return (
      <div className="container py-5">
        {/*Title */}
        <div className="row mb-4">
          <div className="col-lg-8 mx-auto text-center">
            <h3 className="display-6">Payment</h3>
          </div>
        </div>{" "}
        {/* End */}
        {/*Card*/}
        <div className="row mb-4">
          <div className="col-lg-6 mx-auto">
            <div className="cardest">
              <div
                className={
                  paypal
                    ? "card__front card__part paypal"
                    : back
                    ? "card__front card__part front_hover"
                    : "card__front card__part"
                }
              >
                <img
                  className="card__front-square card__square"
                  src="data:image/svg+xml;charset=utf8,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='50px' x='0px' y='0px' viewBox='0 0 40 40' style='enable-background:new 0 0 40 40;' xml:space='preserve'%3E%3Cg id='surface1'%3E%3Cpath fill='%23F5CE85' d='M8.9,34.5c-6.4,0.1-6.4,0.1-6.4-6.4V11.9c0-3.5-0.1-6.4,3.4-6.4h25.3c6.4,0,6.4,0,6.4,6.4v16.3 c0,6.4,0,6.4-6.4,6.4L8.9,34.5z'/%3E%3Cpath fill='%23967A44' d='M31.1,6C37,6,37,6,37,11.9v16.3c0,5.9,0,5.9-5.9,5.9H8.9c-5.9,0-5.9,0-5.9-6V11.9C3,8.2,2.7,6,6,6H31.1 M31.1,5H9.2C2.3,5,2,5,2,11.9v16.3C2,35,2,35,8.9,35h22.3c6.9-0.1,6.9-0.1,6.9-6.9V11.9C38.1,5,38.1,5,31.1,5z'/%3E%3Cpath fill='%23967A44' d='M29,35c-3.3,0-6-2.7-6-6s2.7-6,6-6h8.5v1H29c-2.8,0-5,2.2-5,5s2.2,5,5,5V35z'/%3E%3Cpath fill='%23967A44' d='M11,35v-1c2.8,0,5-2.2,5-5s-2.2-5-5-5H2.5v-1H11c3.3,0,6,2.7,6,6S14.3,35,11,35z'/%3E%3Cpath fill='%23967A44' d='M37.5,17H27c-2.2,0-4-1.8-4-4s1.8-4,4-4h2.1v1H27c-1.7,0-3,1.3-3,3s1.3,3,3,3h10.5V17z'/%3E%3Cpath fill='%23967A44' d='M28,16h1v7.5h-1V16z'/%3E%3Cpath fill='%23967A44' d='M13,17H2.5v-1H13c1.7,0,3-1.3,3-3s-1.3-3-3-3h-2.1V9H13c2.2,0,4,1.8,4,4S15.2,17,13,17z'/%3E%3Cpath fill='%23967A44' d='M11,16h1v7.5h-1V16z'/%3E%3C/g%3E%3C/svg%3E"
                  alt=""
                />
                <i
                  className={
                    paypal
                      ? "fa fa-paypal fa-2x mx-1 card__front-logo card__logo"
                      : cardType === "Visa"
                      ? "fa fa-cc-visa fa-2x mx-1 card__front-logo card__logo"
                      : cardType === "Mastercard"
                      ? "fa fa-cc-mastercard fa-2x mx-1 card__front-logo card__logo"
                      : cardType === "American Express"
                      ? "fa fa-cc-amex fa-2x mx-1 card__front-logo card__logo"
                      : cardType === "Diners Club"
                      ? "fa fa-cc-diners-club fa-2x mx-1 card__front-logo card__logo"
                      : cardType === "Discover"
                      ? "fa fa-cc-discover fa-2x mx-1 card__front-logo card__logo"
                      : cardType === "JCB"
                      ? "fa fa-cc-jcb fa-2x mx-1 card__front-logo card__logo"
                      : "fa fa-credit-card fa-2x mx-1 card__front-logo card__logo"
                  }
                ></i>
                <p className="card_numer">
                  {paypal ? "**** **** **** ****" : cardNumber}
                </p>
                <div className="card__space-75">
                  <span className="card__label">
                    {paypal ? "Paypal" : "Card holder"}
                  </span>
                  <p className="card__info">{paypal ? "***** ***" : owner}</p>
                </div>
                <div className="card__space-25">
                  <span className="card__label">
                    {paypal ? "*****" : "Expires"}
                  </span>
                  <p className="card__info">
                    {paypal ? "**/**" : cardMonth + "/" + cardYear}
                  </p>
                </div>
              </div>
              <div
                className={
                  paypal
                    ? "card__back card__part paypal"
                    : back
                    ? "card__back card__part back_hover"
                    : "card__back card__part"
                }
              >
                <div className="card__black-line" />
                <div className="card__back-content">
                  <div className="card__secret">
                    <p className="card__secret--last">{paypal ? "***" : cvv}</p>
                  </div>
                  <img
                    className="card__back-square card__square"
                    src="data:image/svg+xml;charset=utf8,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='50px' x='0px' y='0px' viewBox='0 0 40 40' style='enable-background:new 0 0 40 40;' xml:space='preserve'%3E%3Cg id='surface1'%3E%3Cpath fill='%23F5CE85' d='M8.9,34.5c-6.4,0.1-6.4,0.1-6.4-6.4V11.9c0-3.5-0.1-6.4,3.4-6.4h25.3c6.4,0,6.4,0,6.4,6.4v16.3 c0,6.4,0,6.4-6.4,6.4L8.9,34.5z'/%3E%3Cpath fill='%23967A44' d='M31.1,6C37,6,37,6,37,11.9v16.3c0,5.9,0,5.9-5.9,5.9H8.9c-5.9,0-5.9,0-5.9-6V11.9C3,8.2,2.7,6,6,6H31.1 M31.1,5H9.2C2.3,5,2,5,2,11.9v16.3C2,35,2,35,8.9,35h22.3c6.9-0.1,6.9-0.1,6.9-6.9V11.9C38.1,5,38.1,5,31.1,5z'/%3E%3Cpath fill='%23967A44' d='M29,35c-3.3,0-6-2.7-6-6s2.7-6,6-6h8.5v1H29c-2.8,0-5,2.2-5,5s2.2,5,5,5V35z'/%3E%3Cpath fill='%23967A44' d='M11,35v-1c2.8,0,5-2.2,5-5s-2.2-5-5-5H2.5v-1H11c3.3,0,6,2.7,6,6S14.3,35,11,35z'/%3E%3Cpath fill='%23967A44' d='M37.5,17H27c-2.2,0-4-1.8-4-4s1.8-4,4-4h2.1v1H27c-1.7,0-3,1.3-3,3s1.3,3,3,3h10.5V17z'/%3E%3Cpath fill='%23967A44' d='M28,16h1v7.5h-1V16z'/%3E%3Cpath fill='%23967A44' d='M13,17H2.5v-1H13c1.7,0,3-1.3,3-3s-1.3-3-3-3h-2.1V9H13c2.2,0,4,1.8,4,4S15.2,17,13,17z'/%3E%3Cpath fill='%23967A44' d='M11,16h1v7.5h-1V16z'/%3E%3C/g%3E%3C/svg%3E"
                    alt=""
                  />
                  <i
                    className={
                      paypal
                        ? "fa fa-paypal fa-2x mx-1 card__back-logo card__logo"
                        : cardType === "Visa"
                        ? "fa fa-cc-visa fa-2x mx-1 card__back-logo card__logo"
                        : cardType === "Mastercard"
                        ? "fa fa-cc-mastercard fa-2x mx-1 card__back-logo card__logo"
                        : cardType === "American Express"
                        ? "fa fa-cc-amex fa-2x mx-1 card__back-logo card__logo"
                        : cardType === "Diners Club"
                        ? "fa fa-cc-diners-club fa-2x mx-1 card__back-logo card__logo"
                        : cardType === "Discover"
                        ? "fa fa-cc-discover fa-2x mx-1 card__back-logo card__logo"
                        : cardType === "JCB"
                        ? "fa fa-cc-jcb fa-2x mx-1 card__back-logo card__logo"
                        : "fa fa-credit-card fa-2x mx-1 card__back-logo card__logo"
                    }
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*End */}
        {/*Voucher*/}
        <div className="row mb-4">
          <div className="middle voucher mx-auto">
            <div className="form-group">
              {" "}
              <label htmlFor="vouchercode">
                <h6>
                  Coupon Code{" "}
                  <span className={voucherValid ? " " : "color_red"}>
                    {voucherValid ? "" : "(Invalid Coupon Code)"}
                  </span>
                </h6>
              </label>{" "}
              <input
                type="text"
                name="vouchercode"
                placeholder="Coupon Code"
                onChange={(e) => {
                  setVoucher(e.target.value);
                }}
                required
                className={voucherValid ? " " : "error_border_voucher"}
              />{" "}
              <a
                href="#!"
                className="right applyvoucher"
                onClick={validateVoucher}
              >
                {couponCheck ? (
                  <span>
                    <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>{" "}
                    Applying
                  </span>
                ) : applyCode ? (
                  "Applied Successfully"
                ) : (
                  "Apply"
                )}
              </a>
            </div>
          </div>
        </div>
        {/*End */}
        {/*Payment Form*/}
        <div className="row">
          <div className="col-lg-6 mx-auto">
            <div className="card ">
              <div className="card-header">
                <div className="shadow-sm pt-4 pl-2 pr-2 pb-2">
                  {/* Credit card form tabs */}
                  <ul
                    role="tablist"
                    className="nav nav-pills rounded nav-fill mb-3"
                  >
                    <li className="nav-item">
                      {" "}
                      <a
                        data-toggle="pill"
                        href="#credit-card"
                        className={!paypal ? "nav-link active " : "nav-link"}
                        onClick={(event) => {
                          event.preventDefault();
                          setPaypal(false);
                        }}
                      >
                        {" "}
                        <i className="fa fa-credit-card mr-2" /> Credit Card{" "}
                      </a>{" "}
                    </li>
                    <li className="nav-item">
                      {" "}
                      <a
                        data-toggle="pill"
                        href="#paypal"
                        className={paypal ? "nav-link active " : "nav-link"}
                        onClick={(event) => {
                          event.preventDefault();
                          setPaypal(true);
                        }}
                      >
                        {" "}
                        <i className="fa fa-paypal mr-2" /> Paypal{" "}
                      </a>{" "}
                    </li>
                    {/*    <li className="nav-item"> <a data-toggle="pill" href="#net-banking" className="nav-link "> <i className="fa fa-mobile-alt mr-2" /> Net Banking </a> </li> */}
                  </ul>
                </div>{" "}
                {/* End */}
                {/* Credit card form content */}
                <div className="tab-content">
                  {/* credit card info*/}
                  <div
                    id="credit-card"
                    className={
                      !paypal
                        ? "tab-pane fade show active pt-3 credit-card"
                        : "tab-pane fade pt-3 credit-card"
                    }
                  >
                    <form onSubmit={confirmPayment}>
                      <div className="form-group">
                        {" "}
                        <label htmlFor="username">
                          <h6>
                            Card Owner{" "}
                            <span className={nameValid ? " " : "color_red"}>
                              {nameValid ? "" : "(Invalid Name)"}
                            </span>
                          </h6>
                        </label>{" "}
                        <input
                          type="text"
                          name="username"
                          placeholder="Card Owner Name"
                          onChange={(e) => {
                            setOwner(e.target.value);
                          }}
                          required
                          className={
                            nameValid
                              ? "form-control "
                              : "form-control error_border"
                          }
                          onBlur={validateName}
                        />{" "}
                      </div>
                      <div className="form-group">
                        {" "}
                        <label htmlFor="cardNumber">
                          <h6>
                            Card number{" "}
                            <span className={cardValid ? " " : "color_red"}>
                              {cardValid ? "" : "(Invalid Card Number)"}
                            </span>
                          </h6>
                        </label>
                        <div className="input-group">
                          {" "}
                          <input
                            type="text"
                            name="cardNumber"
                            placeholder="Valid card number"
                            className={
                              cardValid
                                ? "form-control "
                                : "form-control error_border"
                            }
                            onChange={(e) => {
                              setCardNumber(e.target.value);
                            }}
                            maxLength={16}
                            onBlur={validateCard}
                            required
                          />
                          <div className="input-group-append">
                            {" "}
                            <span className="input-group-text text-muted">
                              {" "}
                              <i className="fa fa-cc-visa mx-1" />{" "}
                              <i className="fa fa-cc-mastercard mx-1" />{" "}
                              <i className="fa fa-cc-amex mx-1" />{" "}
                            </span>{" "}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-8">
                          <div className="form-group">
                            {" "}
                            <label>
                              <span className="hidden-xs">
                                <h6>
                                  Expiration Date{" "}
                                  <span
                                    className={monthValid ? " " : "color_red"}
                                  >
                                    {monthValid ? "" : "(Invalid Expiry Date)"}
                                  </span>
                                </h6>
                              </span>
                            </label>
                            <div className="input-group">
                              {" "}
                              <input
                                type="number"
                                placeholder="MM"
                                name="expmonth"
                                className={
                                  monthValid
                                    ? "form-control "
                                    : "form-control error_border"
                                }
                                required
                                onChange={(e) => {
                                  setCardMonth(e.target.value);
                                }}
                                maxLength={2}
                                onBlur={validateMonth}
                              />{" "}
                              <input
                                type="number"
                                placeholder="YY"
                                name="expyear"
                                className={
                                  monthValid
                                    ? "form-control "
                                    : "form-control error_border"
                                }
                                required
                                onChange={(e) => {
                                  setCardYear(e.target.value);
                                }}
                                maxLength={4}
                                onBlur={validateMonth}
                              />{" "}
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group mb-4">
                            {" "}
                            <label
                              data-toggle="tooltip"
                              title="Three digit CV code on the back of your card"
                            >
                              <h6>
                                CVV{" "}
                                <i className="fa fa-question-circle d-inline" />
                                <span className={cvvValid ? " " : "color_red"}>
                                  {cvvValid ? "" : "Bad CVV"}
                                </span>
                              </h6>
                            </label>{" "}
                            <input
                              type="text"
                              required
                              className={
                                cvvValid
                                  ? "form-control "
                                  : "form-control error_border"
                              }
                              onChange={(e) => {
                                setBack(true);
                                setcvv(e.target.value);
                              }}
                              maxLength={4}
                              onBlur={(e) => {
                                setBack(false);
                                validateCVV();
                              }}
                            />{" "}
                          </div>
                        </div>
                      </div>
                      <div className="card-footer">
                        {" "}
                        <button
                          type="submit"
                          className="subscribe btn btn-primary btn-block shadow-sm"
                        >
                          {" "}
                          Confirm Payment{" "}
                        </button>
                      </div>
                    </form>
                  </div>{" "}
                  {/* End */}
                  {/* Paypal info */}
                  <div
                    id="paypal"
                    className={
                      paypal
                        ? "tab-pane fade pt-3 text-center show active "
                        : "tab-pane fade pt-3 text-center"
                    }
                  >
                    {/* <h6 className="pb-2">Select your paypal account type</h6> */}
                    {/* <div className="form-group "> <label className="radio-inline"> <input type="radio" name="optradio" defaultChecked /> Domestic </label> <label className="radio-inline"> <input type="radio" name="optradio" className="ml-5" />International </label></div> */}
                    <p className="text-muted">
                      {" "}
                      Note: After clicking on the button, you will be directed
                      to a secure gateway for payment. After completing the
                      payment process, you will be redirected back to the
                      website to view details of your order.{" "}
                    </p>

                    <p>
                      {" "}
                      <button
                        type="button"
                        className="btn btn-primary subscribe"
                        onClick={paypaled}
                      >
                        <i className="fa fa-paypal mr-2" /> Go To Paypal
                      </button>{" "}
                    </p>
                  </div>{" "}
                  {/* End */}
                  {/* bank transfer info */}
                  {/*   <div id="net-banking" className="tab-pane fade pt-3">
                    <div className="form-group "> <label htmlFor="Select Your Bank">
                        <h6>Select your Bank</h6>
                      </label> <select className="form-control" id="ccmonth">
                        <option value selected disabled>--Please select your Bank--</option>
                        <option>Bank 1</option>
                        <option>Bank 2</option>
                        <option>Bank 3</option>
                        <option>Bank 4</option>
                        <option>Bank 5</option>
                        <option>Bank 6</option>
                        <option>Bank 7</option>
                        <option>Bank 8</option>
                        <option>Bank 9</option>
                        <option>Bank 10</option>
                      </select> </div>
                    <div className="form-group">
                      <p> <button type="button" className="btn btn-primary "><i className="fas fa-mobile-alt mr-2" /> Proceed Payment</button> </p>
                    </div>
                    <p className="text-muted">Note: After clicking on the button, you will be directed to a secure gateway for payment. After completing the payment process, you will be redirected back to the website to view details of your order. </p>
                  </div> */}{" "}
                  {/* End */}
                  {/* End */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*End */}
      </div>
    );
  }
};

export default Payment;
